<script>
  import AnalyticsComponent from "../../../components/AnalyticsComponent.svelte";

  export let courseId;

  // Example usage
</script>

<AnalyticsComponent courseId={courseId}></AnalyticsComponent>
